var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_4037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 19.592L7 14.592L8.591 13.001L12 16.41L19.41 9.00098L21.005 10.587L12 19.592ZM14 0.000976562C6.268 0.000976562 0 6.26898 0 14.001C0 21.733 6.268 28.001 14 28.001C21.732 28.001 28 21.733 28 14.001C28 6.26898 21.732 0.000976562 14 0.000976562Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_4037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFilled);
export default __webpack_public_path__ + "static/media/check-circle-filled.6debba5e243d6488a38e0d805c1cb7a5.svg";
export { ForwardRef as ReactComponent };